module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/badge/corner-badge/corner-badge.component.scss
// module id = ./src/app/features/badge/corner-badge/corner-badge.component.scss
// module chunks = main